export const LegoBoxStates = {
  ONLINE_UP_TO_DATE: 1,
  ONLINE_NEEDS_UPDATE: 2,
  OFFLINE_UP_TO_DATE: 3,
  OFFLINE_NEEDS_UPDATE: 4,
};
